import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InputFieldComponent } from '../../ui/inputField/inputField.component';
import { IOrganization, ITag } from '../../../types/contactModule';

@Component({
  selector: 'group-selection-input',
  standalone: true,
  imports: [InputFieldComponent],
  templateUrl: './group-selection-input.component.html',
  styleUrl: './group-selection-input.component.css',
})
export class GroupSelectionInputComponent {
  constructor() {}

  @Input({ required: true }) label!: string;
  @Input() placeholder: string = 'Click to add';
  @Input() selections: IOrganization[] | ITag[] = [];
  // emitters
  @Output() removeSelectionEvent = new EventEmitter<IOrganization | ITag>();
  @Output() openSelectionEvent = new EventEmitter<IOrganization | ITag>();

  removeSelection(event: Event, item: IOrganization | ITag) {
    event.stopPropagation();
    // console.log('remove selection clicked', item);
    this.removeSelectionEvent.emit(item)
  }

  openSelector() {
    this.openSelectionEvent.emit();
  }
}
